import React from "react";
import styled from "styled-components";
import { Progress } from "components";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { format } from "date-fns";
import { FaDownload } from "react-icons/fa";
import { API_URL } from "config";

export const TableRow = ({ isLoading, status, data }) => {

  const handleDownload = async () => {
    window.open(API_URL +"/download_file/" + data.job_id, "_blank");
  };

  return isLoading ? (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <Container isLoading>
        <div className="inner">
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Progress isLoading />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
        </div>
      </Container>
    </SkeletonTheme>
  ) : (
    <Container status={status}>
      <div className="inner">
        <RowItem>{data?.name}</RowItem>
        <RowItem>
          <Progress status={data?.status} />
        </RowItem>
        <RowItem></RowItem>
        <RowItem>
          {data?.creation_time
            ? format(new Date(data.creation_time), "MM/dd/yyyy hh:mm a")
            : ""}
        </RowItem>
        <RowItem className="d-flex">
          {data?.complete_time
            ? format(new Date(data.complete_time), "MM/dd/yyyy hh:mm a")
            : ""}

          {data?.status === "DONE" ?        
            <div onClick={handleDownload} className="ml-auto cursor-pointer mr-2">
                <FaDownload />
            </div>
            : ""}
        </RowItem>
      </div>
      {status === "error" && (
        <Error>
          Error: Tasks failed, please review task errors <a href="/#">here</a>.
        </Error>
      )}
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  display: block;
  color: white;
  transition: all 300ms ease;
  font-size: ${(props) => props.theme.palette.m};
  border: 1px solid ${(props) => props.theme.palette.gray};
  border-left: 12px solid
    ${(props) =>
      props.status === "success"
        ? props.theme.palette.success
        : props.status === "warning"
        ? props.theme.palette.warning
        : props.status === "info"
        ? props.theme.palette.info
        : props.status === "error"
        ? props.theme.palette.error
        : props.status === "none"
        ? props.theme.palette.white
        : props.theme.palette.secondary};

  margin: 3px 6px 3px 12px;
  border-radius: 2px;
  .inner {
    display: flex;
    width: 100%;
    padding: 0 0px 0 32px;
    height: 88px;
    &:hover {
      background: ${(props) =>
        props.isLoading
          ? props.theme.palette.items
          : props.theme.palette.itemsHover};
    }

    & > div:nth-child(1) {
      width: 200px;
    }
    & > div:nth-child(2) {
      width: 480px;
    }
    & > div:nth-child(3) {
      width: 200px;
    }
    & > div:nth-child(4) {
      width: 200px;
    }
    & > div:nth-child(5) {
      flex: 1;
    }
  }
`;

const RowItem = styled.div`
  margin: auto 16px auto 0;
`;

const Error = styled.div`
  height: 40px;
  line-height: 40px;
  background: ${(props) => props.theme.palette.error};
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  padding-left: 40px;
  a {
    color: white;
    text-decoration: underline;
  }
`;
